export const ANNOUNCEMENT_PLACEHOLDER_ID = 'announcement'
